/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { EmbersButton } from '../../../../button/button';
import { FilterTagsContainer } from './filtersTagsStyles';
export var FilterTags = function FilterTags(_ref) {
  var _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
    _ref$isInModal = _ref.isInModal,
    isInModal = _ref$isInModal === void 0 ? false : _ref$isInModal,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    data = _ref.data,
    onTagDelete = _ref.onTagDelete,
    onClearAll = _ref.onClearAll;
  var intl = useIntl();
  var clearAllButton = /*#__PURE__*/React.createElement(EmbersButton, {
    level: "tertiary",
    drawingStyle: "text",
    colorTheme: "purple",
    size: "small",
    onClick: onClearAll,
    endIcon: /*#__PURE__*/React.createElement("span", {
      className: "icon-close"
    }),
    className: "EmbersFilterTags-clearAll"
  }, intl.formatMessage({
    id: 'embers.filter.clearAll',
    defaultMessage: 'Clear all'
  }));
  var renderTag = function renderTag(item, index) {
    return /*#__PURE__*/React.createElement(EmbersButton, {
      key: item.code,
      size: "small",
      level: "secondary",
      colorTheme: "purple",
      drawingStyle: "outlined",
      onClick: function onClick(e) {
        e.stopPropagation();
        onTagDelete(index);
      },
      endIcon: /*#__PURE__*/React.createElement("span", {
        className: "icon-close"
      }),
      "aria-label": item.type === 'search' ? intl.formatMessage({
        id: 'embers.table.filterTagLabel.search',
        defaultMessage: 'Remove {tag}'
      }, {
        tag: item.label
      }) : intl.formatMessage({
        id: 'embers.table.filterTagLabel.filter',
        defaultMessage: 'Remove {tag} filter'
      }, {
        tag: item.label
      }),
      className: "EmbersFilterTags-tagItem"
    }, /*#__PURE__*/React.createElement("span", {
      className: "EmbersFilterTags-tagItem-label"
    }, item.label));
  };
  return /*#__PURE__*/React.createElement(FilterTagsContainer, {
    className: classnames('EmbersFilterTags', {
      'EmbersFilterTags-mobile': isMobile
    })
  }, showLabel && data.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "EmbersFilterTags-label"
  }, intl.formatMessage({
    id: 'embers.filter.filterLabel',
    defaultMessage: 'Filters:'
  })), data.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames('EmbersFilterTags-tagsContainer', {
      'EmbersFilterTags-tagsContainer-inModal': isInModal
    })
  }, data.map(function (item, index) {
    if (index === data.length - 1 && !isMobile) return /*#__PURE__*/React.createElement("div", {
      key: "".concat(item.label, "-").concat(index)
    }, renderTag(item, index), clearAllButton);
    return renderTag(item, index);
  })), isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "EmbersFilterTags-clearAllContainer"
  }, clearAllButton) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};